import {ChangeDetectionStrategy, Component, input, TemplateRef} from '@angular/core';
import { NgTemplateOutlet} from "@angular/common";

@Component({
  selector: 'homey-notification-dialog-content',
  imports: [
    NgTemplateOutlet
  ],
  templateUrl: './notification-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationDialogContentComponent {
  public readonly title = input.required<string | TemplateRef<any>>();
  public readonly closeButton = input.required<TemplateRef<any>>();
  public readonly titleColor = input<'black' | 'orange'>('black');
  public readonly noBottomMargin = input<boolean>(false);

  public isTemplateRef = (value: any): value is TemplateRef<any> => {
    return value instanceof TemplateRef;
  }
}
